import { Button, Typography, styled } from '@material-ui/core';

export const MessageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  width: '100%',
  margin: '0 auto',
  padding: theme.spacing(6, 4),
  boxSizing: 'border-box',
  backgroundColor: theme.palette.common.white,
  borderRadius: 24,
  border: `2px dashed ${theme.palette.border}`,
  maxWidth: 500,
}));

export const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  color: theme.palette.grey[400],
  '& svg': {
    width: 72,
    height: 72,
  },
}));

export const MessageTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const MessageDescription = styled(Typography)(({ theme }) => ({
  maxWidth: 480,
  marginBottom: theme.spacing(3),
  color: theme.palette.text.secondary,
  lineHeight: 1.5,
}));

export const ClearFiltersButton = styled(Button)(({ theme }) => ({
  borderRadius: 10,
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1, 2.5),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
